/**
 * @ComponentFor Avensia.Shop.Features.Cms.Blocks.Inspiration.InspirationBlockViewModel
 */
import React from "react";
import { EpiProperty, epiPropertyValue } from "@avensia/nitro5-scope-episerver";
import classnames from "classnames";
import * as styles from "./base.scss";
class InspirationBlock extends React.Component {
    render() {
        return (React.createElement("div", { className: classnames(styles.base, styles[epiPropertyValue(this.props.block.backgroundStyle)]) },
            React.createElement(EpiProperty, { for: this.props.block.mainBody })));
    }
}
export default InspirationBlock;
